"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("@mui/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = (0, _utils.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: 'M4 20H2V4H4V20Z'
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: 'M22 20H20V4H22V20Z'
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: 'M12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12H8C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8V11L8 7L12 3V6Z'
  })]
}));